/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_MenteeInputs */

const en__field_mentee = /** @type {(inputs: _Field_MenteeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentee`)
};

const de__field_mentee = /** @type {(inputs: _Field_MenteeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentee`)
};

/**
* | output |
* | --- |
* | "Mentee" |
*
* @param {_Field_MenteeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_mentee = /** @type {((inputs?: _Field_MenteeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_MenteeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_mentee(inputs)
	return de__field_mentee(inputs)
});